export function createMessageNavigationId() {
  if (typeof window.crypto?.randomUUID === 'function') return window.crypto.randomUUID()
  // HTTP测试环境也支持getRandomValues，不能依赖仅安全上下文提供的randomUUID。
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = [...bytes].map(value => value.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

// 仅把服务端核实过的业务标识转换为既有路由，消息正文不能决定URL。
export function messageTargetRoute(navigation, requestId) {
  const target = navigation.target
  if (!navigation.available || !target) throw new Error(navigation.reason || '原业务入口暂不可用')
  const id = value => {
    if (typeof value !== 'string' || !/^[A-Za-z0-9_.:-]{1,128}$/.test(value)) throw new Error('消息缺少有效的业务定位信息')
    return value
  }
  const query = { messageReturn: requestId }
  switch (target.type) {
    case 'SESSION_REQUEST':
    case 'SESSION_MESSAGE':
    case 'NOTEBOOK':
      if (!/^[A-Za-z0-9_-]{1,2048}$/.test(navigation.directorySlug || '')) throw new Error('工作区定位信息不可用')
      return { path: '/ai-chat', query: { ...query, dir: navigation.directorySlug, session: id(target.sessionId), messageNavigation: requestId } }
    case 'COMMUNITY_REVIEW': return { path: '/admin/community-config', query: { ...query, tab: 'reviews', reviewId: id(target.objectId) } }
    case 'COMMUNITY_SHARE': return { path: '/my-shares', query: { ...query, groupId: id(target.objectId) } }
    case 'RESEARCH_SHARE':
      id(target.objectId)
      return { path: '/ai-chat', query: { ...query, messageNavigation: requestId } }
    case 'ANALYSIS_RUN': return { name: 'AnalysisRun', params: { analysisId: id(target.analysisId) }, query: { ...query, runId: id(target.runId), section: target.section || undefined, reportVersion: target.section === 'report' ? target.version : undefined,
      reportAttemptVersion: target.section === 'report-attempt' ? target.version : undefined,
      resourceRetryId: target.section === 'resource-retry' ? target.objectId : undefined, candidateDigest: target.section === 'resource-retry' ? target.version : undefined } }
    case 'CLINICAL_RUN': return { name: 'TcmClinicalRun', params: { analysisId: id(target.analysisId), runId: id(target.runId) }, query: { ...query, checkpointId: target.checkpointId || undefined,
      revision: target.checkpointId ? target.version : undefined, expectedExecutorRevision: target.section === 'input' ? target.version : undefined } }
    case 'MICROBIOTA_RUN': return { name: 'TcmMicrobiotaDraft', params: { analysisId: id(target.analysisId), runId: id(target.runId) }, query }
    case 'GIFT': return { path: `/subscription-gifts/${encodeURIComponent(id(target.objectId))}`, query: { ...query, directed: '1' } }
    case 'SUBSCRIPTION': return { path: '/billing', query: { ...query, tab: 'subscription', subscriptionId: id(target.objectId) } }
    case 'GIFT_SHARING': return { path: '/billing', query: { ...query, tab: 'subscription', giftView: 'sent', giftId: id(target.objectId) } }
    case 'BALANCE': return { path: target.section === 'capacity' ? '/enterprise/members' : '/billing', query }
    case 'DATASET_BILLING': return { path: '/billing', query }
    case 'RECHARGE': return { path: '/billing', query: { ...query, orderNo: id(target.objectId), tab: 'orders' } }
    case 'INVOICE': return { path: '/billing', query: { ...query, invoiceId: id(target.objectId), tab: 'orders' } }
    case 'FEEDBACK': return { path: '/feedback', query: { ...query, feedbackId: id(target.objectId) } }
    case 'ENTERPRISE': return { path: '/profile', query }
    default: throw new Error('此消息没有可用的业务跳转入口')
  }
}

// 原iframe确认定位成功才完成导航；失败/超时不丢失消息详情。
export function waitForMessageNavigation(requestId, identityId, signal, timeout = 120000) {
  return new Promise((resolve, reject) => {
    const finish = (error, value) => {
      clearTimeout(timer); window.removeEventListener('biointelos-message-navigation-result', receive)
      signal?.removeEventListener('abort', cancel)
      if (error) reject(error); else resolve(value)
    }
    const receive = event => {
      if (event.detail?.requestId !== requestId || String(event.detail.identityId) !== String(identityId)) return
      finish(event.detail.ok ? null : new Error(event.detail.reason || '无法定位原业务，请重试'), event.detail)
    }
    const cancel = () => finish(new Error('身份已切换，导航已取消'))
    const timer = setTimeout(() => finish(new Error('业务页面未确认就绪，请重试')), timeout)
    window.addEventListener('biointelos-message-navigation-result', receive)
    signal?.addEventListener('abort', cancel, { once: true })
    if (signal?.aborted) cancel()
  })
}
